<template>
  <v-app :dark="darkTheme">
    <v-navigation-drawer v-model="drawer" clipped fixed app v-if="authenticatedUserExists" purple>
      <!-- <v-btn @click="toggleStaff" v-if="isStaff()">Turn Off Staff Mode</v-btn>
      <v-btn @click="toggleStaff" v-if="!isStaff()">Turn On Staff Mode</v-btn> -->
      <div v-if="isStaff()">
        <v-divider>
        </v-divider>
        <v-subheader>ALL PERIODS</v-subheader>
        <v-list dense>
          <v-list-tile v-for="item in staffItems" :key="item.title"
          router :to="item.link" >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
      <div v-else>
        <v-list dense>
          <v-list-tile v-for="item in nonStaffItems" :key="item.title"
          router :to="item.link" >
            <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        </div>
        <v-divider>
        </v-divider>

      <v-subheader>Harvest</v-subheader>
      <v-list dense>
        <v-list-tile
          v-for="item in harvestItems"
          :key="item.title"
          router :to="item.link"
          v-if="(item.showOnlyToNonStaff  && !isStaff())  || !item.showOnlyToNonStaff"
        >
          <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <div v-if="isStaff()">
        <v-divider>
        </v-divider>
        <v-subheader>Staff Harvest</v-subheader>
        <v-list dense>
          <v-list-tile v-for="item in staffHarvest" :key="item.title"
          router :to="item.link" >
            <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider>
        </v-divider>
        <v-subheader>Summaries</v-subheader>
        <v-list dense>
          <v-list-tile v-for="item in summaries" :key="item.title"
          router :to="item.link" >
            <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-flex xs2><v-toolbar-title>Cellarworx 2.0</v-toolbar-title></v-flex>
        <v-flex xs2>
           <v-switch label="Theme Color" color="primary" @change="themeChanged" hide-details></v-switch>
        </v-flex>
        <v-flex xs8>
            <template v-if="!authenticatedUserExists">
              <v-toolbar-items >
                <v-spacer></v-spacer>
                <v-btn flat router :to="{name: 'register'}">Register</v-btn>
                <v-btn flat router :to="{name: 'login'}">Login</v-btn>
              </v-toolbar-items>
            </template>
            <template v-else>
              <v-toolbar-items>
              <v-flex xs2></v-flex>
              <v-flex xs3>
                <v-autocomplete single-line v-on:change="updateClient"
                  :value ='client'
                  :items='clients'
                  :filter='filterClients'
                  item-text='CLIENTNAME'
                  item-value='CLIENTNAME'
                  return-object
                  label='Clients'
                  class="subheading font-weight-bold"
                >
                <template slot="selection" slot-scope="data">
                  {{ data.item.CLIENTNAME }} - {{ data.item.CODE }}
                </template>
                <template slot="item" slot-scope="data">
                  {{ data.item.CLIENTNAME }} - {{ data.item.CODE }}
                </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs1>
                <v-autocomplete single-line v-on:change="updateVintage"
                  :value ='vintage'
                  :items='vintages'
                  label='Vintages'
                  class="subheading font-weight-bold"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4></v-flex>
              <v-flex xs2>
                <v-layout justify-end align-center>
                  <template v-if="authenticatedUserExists">
                    <h4 v-if="user">{{user.username}}</h4>
                    <v-btn flat @click="logoutUser" icon><v-icon>logout</v-icon></v-btn>
                  </template>
                </v-layout>
              </v-flex>
              </v-toolbar-items>
            </template>
        </v-flex>
    </v-toolbar>
    <v-content app>
      <v-container fluid>
        <router-view :key="$router.path"></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios'
import colors from 'vuetify/es5/util/colors'
import myMixins from './mixins/myMixins'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// import * as firebase from 'firebase'
// import jsPDF from 'jspdf'
export default {
  data () {
    return {
      drawer: null,
      darkTheme: true,
      harvestItems: [
        {
          color: 'blue',
          icon: 'traffic',
          title: 'FRUIT ARRIVAL SCHEDULE',
          link: '/SCPCalendar'
        },
        {
          color: 'blue',
          icon: 'date_range',
          title: 'PRESS CALENDAR',
          link: '/pressCalendar'
        },
        {
          color: 'blue',
          icon: 'memory',
          title: 'FERMENTATION PROTOCOLS',
          link: '/FermProtocols'
        },
        {
          color: 'orange',
          icon: 'fa-balance-scale',
          title: 'WEIGH TAGS',
          link: '/weightags'
        },
        {
          color: 'green',
          icon: 'fa-leaf',
          title: 'VINEYARDS',
          link: '/vineyards'
        }
      ],
      staffHarvest: [
        //         {
        //   color: 'blue',
        //   icon: 'record_voice_over',
        //   title: 'Layout',
        //   link: '/layout'
        // },

        {
          color: 'orange',
          icon: 'fa-balance-scale',
          title: 'DAILY WEIGH TAGS',
          link: '/dailyWeighTags'
        },
        {
          color: 'orange',
          icon: 'ballot',
          title: 'SCPs FOR CLIPBOARD',
          link: '/scpsForClipboard'
        },
        {
          color: 'blue',
          icon: 'cached',
          title: 'GENERATE PO/PD WORKORDERS',
          link: '/popdWorkOrders'
        },
        {
          color: 'blue',
          icon: 'fa-calendar',
          title: 'ASSET SCHEDULES',
          link: '/assetSchedules?tank'
        }
      ],
      nonStaffItems: [
        {
          color: 'blue',
          icon: 'record_voice_over',
          title: 'OUTSTANDING WORK ORDERS',
          link: '/outstandingWorkOrders?isStaff=false'
        },
        {
          color: 'blue',
          icon: 'calendar_today',
          title: 'WO CALENDAR',
          link: '/woCalendar'
        },
        {
          color: 'blue',
          icon: 'list',
          title: 'LOT MANAGEMENT',
          link: '/lots'
        },
        {
          color: 'brown',
          icon: 'fa-clipboard-list',
          title: 'BILL OF LADINGS',
          link: '/bols'
        },
        {
          color: 'brown',
          icon: 'fa-clipboard-list',
          title: 'LAB TESTS SUMMARY',
          link: '/labSummary'
        }
      ],
      staffItems: [
        {
          color: 'blue',
          icon: 'record_voice_over',
          title: 'OUTSTANDING WORK ORDERS',
          link: '/outstandingWorkOrders?isStaff=true'
        },
        {
          color: 'blue',
          icon: 'calendar_today',
          title: 'WO CALENDAR',
          link: '/woCalendar'
        },
        {
          color: 'blue',
          icon: 'list',
          title: 'LOT MANAGEMENT',
          link: '/lots'
        },
        {
          color: 'brown',
          icon: 'fa-clipboard-list',
          title: 'BILL OF LADINGS',
          link: '/bols'
        },
        {
          color: 'brown',
          icon: 'fa-clipboard-list',
          title: 'LAB TESTS SUMMARY',
          link: '/labSummary'
        }
      ],
      summaries: [
        {
          color: 'orange',
          icon: 'satellite',
          title: 'VINTAGE WEIGH TAGS',
          link: '/weighTagsByVintage'
        },
        {
          color: 'orange',
          icon: 'fa-balance-scale',
          title: 'FACILITY WEIGH TAGS',
          link: '/facilityWeights'
        }
      ],
      menuItems: [
        {
          color: 'blue',
          icon: 'record_voice_over',
          title: 'Outstanding Work Orders',
          link: '/outstandingWorkOrders',
          showOnlyToNonStaff: true // we don't want this shown if you are logged in as staff
        },
        {
          color: 'green',
          icon: 'fa-leaf',
          title: 'Vineyards',
          link: '/vineyards'
        },
        {
          color: 'brown',
          icon: 'fa-clipboard-list',
          title: 'Bill Of Ladings',
          link: '/bols'
        }
      ]
    }
  },
  mixins: [myMixins],
  created () {
    this.$cookies.config('30d')
    this.darkTheme = this.useDarkTheme
    this.$vuetify.theme.primary = colors.blue
    this.$store.commit('updateVarietals')
    this.$store.commit('updateAssets')
    this.$store.commit('updateAppellations')
    this.$store.commit('updateUsers')
    this.$store.commit('updateRegions')
    this.$store.commit('updateFacilities')
  },
  computed: {
    useDarkTheme () {
      if (this.$cookies.isKey('darkTheme')) {
        return this.$cookies.get('darkTheme') === 'true'
      }
      this.$cookies.set('darkTheme', true)
      return true
    },
    authenticatedUser () {
      return this.$store.getters.authenticatedUser
    },
    authenticatedUserExists () {
      return (this.$store.getters.authenticatedUser !== null && this.$store.getters.authenticatedUser !== undefined)
    },
    url () {
      return process.env.VUE_APP_BACKEND
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      if (this.$store.state.client.CODE) {
        return this.$store.state.client.CODE.toUpperCase()
      } else {
        return '---'
      }
    },
    users () {
      return this.$store.state.users
    },
    user () {
      return this.$store.state.user
    },
    client () {
      return this.$store.state.client
    },
    clients () {
      return this.$store.state.clients
    },
    vintages () {
      return this.$store.state.vintages
    }
  },
  watch: {
    authenticatedUser: function (nv, ov) {
      firebase.firestore().collection('users').where('email', '==', nv.user.email).get().then(snapshot => {
        let username = snapshot.docs[0].data().username
        axios
          .get(process.env.VUE_APP_BACKEND+'users?search='+username)
          .then((response) => {
            console.log('authenticated with user: ' + username)
            //            console.log(JSON.stringify(response.data.data, null, 2))
            let user = response.data.data[0]
            this.updateUser(user)
          })
      })
    },
    vintage: function (oldv, newv) {
      this.$store.commit('updateLots')
    },
    client: function (nv, ov) {
    //  this.$cookies.set('client', nv)
    //  console.log('set client cookie')
      this.$store.commit('updateVintages')
      this.$store.commit('updateVineyards')
      this.$store.commit('updateLots')
    }
  },
  methods: {
    toggleStaff () {
      if (this.$store.state.user.staff === 'NO') {
        this.$store.state.user.staff='YES'
      } else {
        this.$store.state.user.staff='NO'
      }
    },
    logoutUser () {
      this.$store.commit('clearUser')
      this.$router.go('/')
    },
    filterClients (item, queryText, itemText) {
      //   console.log(JSON.stringify(item, null, 2))
      return (item.CLIENTNAME.includes(queryText.toUpperCase()) || item.CODE.includes(queryText.toUpperCase()))
    },
    themeChanged () {
      var value = true
      if (this.$cookies.isKey('darkTheme')) {
        value = this.$cookies.get('darkTheme') === 'true'
      }
      this.$cookies.set('darkTheme', !value)
      this.darkTheme = !value
    },
    loadAllClients () {
      axios
        .get(process.env.VUE_APP_BACKEND+'clients?active=YES')
        .then((response) => {
          if (this.$cookies.isKey('client')) {
            this.$store.state.client = this.$cookies.get('client')
          } else {
            this.$store.state.client = response.data.data[0]
          }
          this.$store.state.clients = response.data.data
        })
    },
    updateUser (value) {
      this.$store.commit('updateUser', value)
      let $this = this
      if (value.staff === 'YES') {
        this.$store.commit('loadAllClients')
      } else {
        var clientList = []
        if (value.Groups.length === 0) {
          clientList.push(value.Client)
        } else {
          value.Groups.forEach(function (item) {
            clientList.push(item.Client)
          })
        }
        this.$store.commit('updateClients', clientList)
      }
    },
    updateVintage (value) {
      this.$store.state.vintage = value
      console.log('vintage: ' + value)
    },
    updateClient (value) {
      this.$store.state.gotoLotsPage = true
      this.$store.state.client = value
    }
  }
}
</script>
<style>
/* .v-subheader {
 font-weight: bold;
  font-size: 18px;
  color: rgba(255,255,255,0.7);
} */
/* .v-list__tile__title {
  font-weight: normal;
  color: rgba(255,255,255,1);
} */
</style>
